class Empresa {
    public ativo = true
    public cnpj = ''
    public codigoFinanceiro = ''
    public email = ''
    public emailContador = ''
    public id = 0
    public pendencia = ''
    public razaoSocial = ''
    public tomador = []
}

export { Empresa }
export default Empresa
